<template>
  <b-row>
    <b-col cols="12" class="mt-4">
      <div class="titlePage mb-3">Liberação</div>
    </b-col>
    <b-col cols="12" class="mb-4" v-if="liberarExportacao">
      <fcc-button @click="listarInclusao"> Inclusão de gabaritos e provas</fcc-button>
      <fcc-button class="ml-2" @click="listarAlteracao">Alteração de gabaritos e provas</fcc-button>
    </b-col>
    <b-col cols="12">
      <fcc-table
        striped
        hover
        :fields="fieldsLiberacao"
        :items="lstLiberacao"
        responsive
        :por-page="'100'"
        pagination
        :optionsButton="optionButton"
        :mostrarQuantidade="false"
      />
      <fcc-lista-inclusao-alteracao
        v-if="carregaTipo.inclusao || carregaTipo.alteracao"
        :lstInclusao="lstInclusao"
        :carregaTipo="carregaTipo"
        @listarInclusao="listarInclusao"
        @listarAlteracao="listarAlteracao"
        :idNotificacao="idNotificacao"
        :lstAlteracao="lstAlteracao"
      />
    </b-col>
  </b-row>
</template>
<script>
import axios from 'axios'
import fccListaInclusaoAlteracao from './fccListaInclusaoAlteracao.vue'

export default {
  data() {
    return {
      lstInclusao: [],
      lstAlteracao: [],
      carregaTipo: {
        inclusao: false,
        alteracao: false
      },
      loading: {
        inclusao: true,
        alterar: true
      },
      fieldsLiberacao: [
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'dataupload', label: 'Data da Liberação', sortable: true }
      ],
      optionButton: []
    }
  },
  components: {
    fccListaInclusaoAlteracao
  },
  methods: {
    listarInclusao() {
      this.carregaTexto('Carregando')
      const carregaTipo = { ...carregaTipo }
      this.carregaTipo.inclusao = false
      this.carregaTipo.alteracao = false
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/ListaInclusaoGabaritoProva/${this.idNotificacao}/${this.dadosUserSession.usuCdFuncionario}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstInclusao = response.data
          this.carregaTipo.inclusao = true
          this.carregaTexto.alteracao = carregaTipo.alteracao
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    listarAlteracao() {
      const carregaTipo = { ...carregaTipo }
      this.carregaTipo.alteracao = false
      this.carregaTipo.inclusao = false
      this.carregaTexto('Carregando')
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/ListaAlteracaoGabaritoProva/${this.idNotificacao}/${this.dadosUserSession.usuCdFuncionario}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.carregaTipo.alteracao = true
          this.carregaTexto.inclusao = carregaTipo.inclusao
          this.lstAlteracao = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    idNotificacao: String,
    lstLiberacao: Array,
    liberarExportacao: Boolean,
    baseUrlPublicacao: String
  }
}
</script>